<template>
  <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <tooltip></tooltip>
    <alert></alert>
    <modal></modal>
    <delete></delete>
  </div>
</template>
<script>
  import Alert from '@/components/alert'
  import Modal from '@/components/modal'
  import Delete from '@/components/delete'
  export default {
    name: 'App',
    components:{
      Alert,Modal,Delete
    },
    created() {
      // this.getProvinces();
    },
    methods: {
      getProvinces() {
        this.$store.dispatch('provinces/getProvinces');
      },
    }
  }
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    overflow: hidden;
  }
</style>
